module.exports = __webpack_public_path__ + "img/bg-3_mobile_word.c5d417a5.jpg";